import{generateUniqueID as e}from"./generateUniqueID.js";var n=function(n,r){return{name:n,value:null!=r?r:-1,delta:0,entries:[],id:e()}};export{n as initMetric};
